import {assertDefined} from "@wix/devzai-utils-common";
import {BymoTemplateMetadata} from "../../doppe-sdk";
import {BymoTemplatesIds} from "../doppe-templates/doppe-templates";
import {
    BymoTemplateBasicTemplateMetadata
} from "../../components/bymo-templates/bymo-template-basic/bymo-template-basic.metadata";
import {
    BymoTemplatePreRollTemplateMetadata
} from "../../components/bymo-templates/bymo-template-pre-roll/bymo-template-pre-roll.metadata";
import {
    BymoTemplateSpeedDialTemplateMetadata
} from "../../components/bymo-templates/bymo-template-speed-dial/bymo-template-speed-dial.metadata";
import {
    BymoTemplateActionPreviewTemplateMetadata
} from "../../components/bymo-templates/bymo-template-action-preview/bymo-template-action-preview.metadata";
import {
    BymoTemplateActionInPagePreviewMetadata
} from "../../components/bymo-templates/bymo-template-action-in-page-preview/bymo-template-action-in-page-preview.metadata";
import {
    BymoTemplateActionInLandingPagePreviewMetadata
} from '../../components/bymo-templates/bymo-template-action-in-landing-page-preview/bymo-template-action-in-landing-page-preview.metadata';
import {
    BymoTemplatePagePreviewMetadata
} from "../../components/bymo-templates/bymo-template-page-preview/bymo-template-page-preview.metadata";

export class DoppeBymoTemplatesMetadataStore {

    private bymoPagesTemplatesMetadata: Record<BymoTemplatesIds, BymoTemplateMetadata<any>> = {
        [BymoTemplatesIds.ActionPreview]: BymoTemplateActionPreviewTemplateMetadata,
        [BymoTemplatesIds.ActionInPagePreview]: BymoTemplateActionInPagePreviewMetadata,
        [BymoTemplatesIds.PagePreview]: BymoTemplatePagePreviewMetadata,
        [BymoTemplatesIds.ActionInLandingPagePreview]: BymoTemplateActionInLandingPagePreviewMetadata,
        [BymoTemplatesIds.BasicForActionPreview]: BymoTemplateBasicTemplateMetadata,
        [BymoTemplatesIds.Basic]: BymoTemplateSpeedDialTemplateMetadata,
        [BymoTemplatesIds.PreRoll]: BymoTemplatePreRollTemplateMetadata,
        [BymoTemplatesIds.SpeedDial]: BymoTemplateSpeedDialTemplateMetadata,
    }

    public getBymoPageTemplateMetadata (templateId: string) {
        return this.bymoPagesTemplatesMetadata[templateId as BymoTemplatesIds] as (BymoTemplateMetadata<{}> | undefined);
    }

    public assertBymoPageTemplateMetadata (templateId: string) {
        return assertDefined(this.getBymoPageTemplateMetadata(templateId), `Could not find a page template with id ${templateId}`)
    }
}